var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.languages !== '')?_c('div',_vm._l((_vm.languages),function(lang,i){return _c('span',{key:lang.name,staticClass:"language"},[_c(lang.url ? 'a' : 'span',{tag:"component",attrs:{"href":lang.url,"target":lang.url ? '_blank' : null}},[_vm._v(" "+_vm._s(lang.name)+_vm._s(i < _vm.languageCount - 1 ? ',' : '')+" ")])],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }